import { createApiInstance } from "../InstanceAPI";

/**
 * Transferência entre turmas no Sponte + sincronização de notas locais.
 * Requer JWT (rota privada).
 *
 * @param {Object} body
 * @param {string} [body.unit] — opcional; senão use a unidade do usuário logado no cliente
 * @param {number|string} body.AlunoID
 * @param {number|string} body.TurmaOrigemID
 * @param {number|string} body.TurmaDestinoID
 * @param {string} [body.Observacoes]
 */
export const transferStudentBetweenClassrooms = async (body) => {
  const api = createApiInstance();
  const { data } = await api.post("/sponte/classrooms/transfer-student", body);
  return data;
};
